
import {
  Text
} from '@components/1-atoms';
import ListItem from '@components/2-molecules/ListItem';
import styled, { css } from '@emotion/native';
import React, { FC } from 'react';
import { View } from 'react-native';

import CheckedIcon from '@assets/icons/checked';

import { ChartDataPointProps } from '@/interfaces/chart.interface';
import * as utils from '@lib/utils';

const FlatList = styled.FlatList``;

type Props = {
  data: ChartDataPointProps[];
  defaultValue: ChartDataPointProps | null;
  onPress?: (point: ChartDataPointProps) => void;
}

const ListChart: FC<Props> = ({ data, defaultValue, onPress, ...props }) => {

  const _renderItem = ({ item, index }: { item: any, index: number }) => {
    return (
      <ListItem
        {...props}
        sub={`${item.label}`}
        onPress={() => { onPress?.(item) }}
        right={(utils.deepEqual(defaultValue, item) && <CheckedIcon />)}
      >
        <Text>{utils.formatDate(item.date, "MMMM, yyy")}</Text>
      </ListItem>
    );
  };


  return (
    <View>
      {/*
        <Row>
          <Input left={<Search />} placeholder='Search keyword(s)' />
          <Spacer h={0.6} />
        </Row>
        */}

      {/* CASE 1: */}
      {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
      {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
      {/* is taller than the screen. */}

      {/* This SectionList is itself a scrollable view. */}
      {/* However, nested while not supported in react-native is supported in react-native-web */}

      {/* CASE 2: */}
      {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
      {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
      {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

      {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
      {/*               The view contains the list inside its immediate container.*/}
      <View style={css(`width: 100%; height: auto; `)}>


        <FlatList
          data={data}
          renderItem={_renderItem}
          keyExtractor={(item: any) => item.period[1]}
        />


      </View>

    </View>
  );

};


export default ListChart;





// type Section = { title: string; data: ReadonlyArray<ChartDataPointProps> };

// // Create a typed SectionList component
// const SectionList = styled(RNSectionList<ChartDataPointProps, Section>)``;

// <SectionList
//   scrollEnabled={(Platform.OS === 'web') ? true : false}
//   sections={data as Section[]}
//   keyExtractor={(item) => `${Date.now()}`}
//   renderItem={_renderItem}
//   // renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title.toUpperCase()} />}
//   renderSectionFooter={(/* { section: { title } } */) => <Spacer h={1} />}
// />